import { EventTypes, AnalyticsEvent } from './interfaces';

export function getAnalyticsEvents(
  applicationName: string
): { [key in EventTypes]: AnalyticsEvent } {
  const baseEvent = {
    category: 'FormCompletionFeedback',
    action: applicationName
  };

  return {
    submitFeedback: {
      ...baseEvent,
      label: 'submit-feedback'
    },
    skipFeedback: {
      ...baseEvent,
      label: 'skip-feedback'
    },
    thumbsUp: {
      ...baseEvent,
      label: 'thumbs-up'
    },
    thumbsDown: {
      ...baseEvent,
      label: 'thumbs-down'
    }
  };
}
